/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoModelsDesign,
    SharedserviceMelcoModelsDesignFromJSON,
    SharedserviceMelcoModelsDesignToJSON,
    SharedserviceMelcoModelsDesignMetadata,
    SharedserviceMelcoModelsDesignMetadataFromJSON,
    SharedserviceMelcoModelsDesignMetadataToJSON,
    SharedserviceMelcoModelsDesignReferences,
    SharedserviceMelcoModelsDesignReferencesFromJSON,
    SharedserviceMelcoModelsDesignReferencesToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemToJSON,
    SharedserviceMelcoModelsNotification,
    SharedserviceMelcoModelsNotificationFromJSON,
    SharedserviceMelcoModelsNotificationToJSON,
    SharedserviceMelcoModelsUpdateDesign,
    SharedserviceMelcoModelsUpdateDesignFromJSON,
    SharedserviceMelcoModelsUpdateDesignToJSON,
} from '../models';

export interface DesignsApiUserDesignsDeleteRequest {
    id: string;
    force?: boolean;
}

export interface DesignsApiUserDesignsDownloadRequest {
    id: string;
    publishState?: string;
}

export interface DesignsApiUserDesignsDuplicateRequest {
    id: string;
}

export interface DesignsApiUserDesignsGetDefRequest {
    id: string;
    publishState?: string;
}

export interface DesignsApiUserDesignsMetadataRequest {
    file?: Blob;
}

export interface DesignsApiUserDesignsPreviewRequest {
    id: string;
    width?: number;
    publishState?: string;
}

export interface DesignsApiUserDesignsPrintQueueUpdateFileRequest {
    id: string;
    file?: Blob;
}

export interface DesignsApiUserDesignsPrintQueueUploadRequest {
    file?: Blob;
}

export interface DesignsApiUserDesignsReferencesRequest {
    id: string;
}

export interface DesignsApiUserDesignsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
    service?: string;
}

export interface DesignsApiUserDesignsUpdateRequest {
    id: string;
    sharedserviceMelcoModelsUpdateDesign?: SharedserviceMelcoModelsUpdateDesign;
}

export interface DesignsApiUserDesignsUpdateFileRequest {
    id: string;
    file?: Blob;
}

export interface DesignsApiUserDesignsUploadRequest {
    file?: Blob;
}

/**
 * 
 */
export class DesignsApi extends runtime.BaseAPI {

    /**
     */
    async userDesignsDeleteRaw(requestParameters: DesignsApiUserDesignsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignsDelete(requestParameters: DesignsApiUserDesignsDeleteRequest): Promise<void> {
        await this.userDesignsDeleteRaw(requestParameters);
    }

    /**
     */
    async userDesignsDownloadRaw(requestParameters: DesignsApiUserDesignsDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDownload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/download`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userDesignsDownload(requestParameters: DesignsApiUserDesignsDownloadRequest): Promise<Blob> {
        const response = await this.userDesignsDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDuplicateRaw(requestParameters: DesignsApiUserDesignsDuplicateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDuplicate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/duplicate`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsDuplicate(requestParameters: DesignsApiUserDesignsDuplicateRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsDuplicateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsGetDefRaw(requestParameters: DesignsApiUserDesignsGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsGetDef(requestParameters: DesignsApiUserDesignsGetDefRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsMetadataRaw(requestParameters: DesignsApiUserDesignsMetadataRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignMetadata>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/metadata`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignMetadataFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsMetadata(requestParameters: DesignsApiUserDesignsMetadataRequest): Promise<SharedserviceMelcoModelsDesignMetadata> {
        const response = await this.userDesignsMetadataRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsPreviewRaw(requestParameters: DesignsApiUserDesignsPreviewRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsPreview.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.width !== undefined) {
            queryParameters['width'] = requestParameters.width;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/preview`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignsPreview(requestParameters: DesignsApiUserDesignsPreviewRequest): Promise<void> {
        await this.userDesignsPreviewRaw(requestParameters);
    }

    /**
     */
    async userDesignsPrintQueueUpdateFileRaw(requestParameters: DesignsApiUserDesignsPrintQueueUpdateFileRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsNotification>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsPrintQueueUpdateFile.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/printqueue/{Id}/update`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsNotificationFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsPrintQueueUpdateFile(requestParameters: DesignsApiUserDesignsPrintQueueUpdateFileRequest): Promise<SharedserviceMelcoModelsNotification> {
        const response = await this.userDesignsPrintQueueUpdateFileRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsPrintQueueUploadRaw(requestParameters: DesignsApiUserDesignsPrintQueueUploadRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsNotification>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/printqueue/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsNotificationFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsPrintQueueUpload(requestParameters: DesignsApiUserDesignsPrintQueueUploadRequest): Promise<SharedserviceMelcoModelsNotification> {
        const response = await this.userDesignsPrintQueueUploadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsReferencesRaw(requestParameters: DesignsApiUserDesignsReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignReferencesFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsReferences(requestParameters: DesignsApiUserDesignsReferencesRequest): Promise<SharedserviceMelcoModelsDesignReferences> {
        const response = await this.userDesignsReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsSearchRaw(requestParameters: DesignsApiUserDesignsSearchRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.service !== undefined) {
            queryParameters['service'] = requestParameters.service;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsSearch(requestParameters: DesignsApiUserDesignsSearchRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem> {
        const response = await this.userDesignsSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsUpdateRaw(requestParameters: DesignsApiUserDesignsUpdateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/designs/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsUpdateDesignToJSON(requestParameters.sharedserviceMelcoModelsUpdateDesign),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsUpdate(requestParameters: DesignsApiUserDesignsUpdateRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsUpdateFileRaw(requestParameters: DesignsApiUserDesignsUpdateFileRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsUpdateFile.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/{Id}/update`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsUpdateFile(requestParameters: DesignsApiUserDesignsUpdateFileRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsUpdateFileRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsUploadRaw(requestParameters: DesignsApiUserDesignsUploadRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsUpload(requestParameters: DesignsApiUserDesignsUploadRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsUploadRaw(requestParameters);
        return await response.value();
    }

}
